<template>
  <div>
    <div class="row align-items-end">
      <div class="col-3">
        <label for="">Référence</label>
        <input
          type="text"
          :disabled="true"
          :value="user.employee_reference"
          class="form-control"
        />
      </div>
      <div class="col">
        <label for="employeeSelect">Employé <span class="text-danger">*</span></label>
        <vue-select
          id="employeeSelect"
          :options="employees"
          v-model="user.employee_reference"
          placeholder="Choisir un employé"
          labelColumn="fullName"
          valueColumn="reference"
        />
      </div>

      <div class="col-auto">
        <label for=""> </label>
        <button
          @click="$router.push({ name: 'employees-create' })"
          class="btn btn-secondary"
        >
          <i class="bi bi-plus-square"></i>
          Créer un employée
        </button>
      </div>
      <div class="col-xl-3 col-12">
        <label for="roleSelect">Rôle <span class="text-danger">*</span></label>
        <vue-select
          id="roleSelect"
          :options="user_roles"
          v-model="user.user_role_reference"
          placeholder="Choisir un rôle"
          labelColumn="fullName"
          valueColumn="reference"
        />
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-3">
        <label for="">Nom d'utilisateur (username)</label>
        <input type="text" v-model="user.username" class="form-control" />
      </div>

      <div class="col-3">
        <label for="">Mot de passe</label>
        <input type="text" v-model="user.password" class="form-control" />
      </div>
    </div>

    <br />
    <div class="row mt-3 justify-content-between">
      <div class="col-auto"></div>
      <div class="col-auto">
        <button class="btn btn-success" @click="save(user)">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueSelect from "@/components/cards/VueSelect.vue";

export default {
  components: { VueSelect },
  data() {
    return {
      user: {},
    };
  },
  computed: {
    ...mapGetters("user", {
      user_roles: "getUserRoles",
    }),
    ...mapGetters("employee", {
      employees: "getAll",
    }),
  },
  methods: {
    async save(data) {
      await this.$store.dispatch("user/store", data);
    },
  },
  async mounted() {
    await this.$store.dispatch("employee/getAll");
    await this.$store.dispatch("user/getUserRoles");
    const ref = this.$route.query.employeeReference;
    if (ref) {
      this.$set(this.user, "employee_reference", ref);
    }
  },
};
</script>
